export default __webpack_public_path__ + "static/media/activeGrayMarker.57220f9d.svg";